import { type PropsWithChildren } from 'react'

import { Stack, type SxProps, type Theme } from '@mui/material'
import { useTheme } from '@mui/styles'

import Footer from '~/Footer'
import Header from '~/Header'

interface MainLayoutProps extends PropsWithChildren {
  hasGrayBackground?: boolean
  sx?: SxProps<Theme>
}

export default function MainLayout({
  sx,
  children,
  hasGrayBackground,
}: MainLayoutProps) {
  const { spacing } = useTheme()
  const navbarHeight = spacing(8.5)

  return (
    <Stack
      sx={{
        minHeight: '100vh',
        backgroundColor: hasGrayBackground
          ? theme => theme.palette.background.paper
          : undefined,
        ...sx,
      }}
    >
      <Header />
      <Stack sx={{ flex: 1, marginTop: navbarHeight }}>{children}</Stack>
      <Footer />
    </Stack>
  )
}
